<template>
    <v-app>
        <v-toolbar app class="app-toolbar">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Profile</v-toolbar-title>
            <v-spacer></v-spacer>
            <!--<v-btn icon>-->
            <!--<v-icon class="icon-light" @click="save">save</v-icon>-->
            <!--</v-btn>-->
            <v-btn flat @click="save">
                Save
            </v-btn>
            <v-tabs slot="extension" v-model="tab" color="transparent" grow>
                <v-tabs-slider color="#a8cf45"></v-tabs-slider>

                <v-tab key="personal">Personal</v-tab>
                <v-tab key="address">Address</v-tab>
                <v-tab key="password" v-if="!config.registration.free">Password</v-tab>
            </v-tabs>
        </v-toolbar>
        <v-content>
            <v-form lazy-validation ref="form" style="width: 100%">
                <v-tabs-items v-model="tab">
                    <v-tab-item key="personal">
                        <v-container color="transparent">
                            <v-layout row full-width>
                                <v-flex xs-12>
                                    <v-text-field label="First Name" v-model="user.name" :rules="[rules.required]"></v-text-field>

                                    <v-text-field label="Last Name" v-model="user.surname" :rules="[rules.required]"></v-text-field>

                                    <v-select :items="genders" v-model="user.sex" label="Gender"/>
                                    <v-select :items="languages" v-model="user.language_id" label="Language" item-text="label" item-value="id"/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item key="address">
                        <v-container color="transparent">
                            <v-layout row full-width>
                                <v-flex xs-12>
                                    <v-text-field v-model="user.home_address_1" label="Address Line 1" type="text"/>
                                    <v-text-field v-model="user.home_address_2" label="Address Line 2" type="text"/>
                                    <v-text-field v-model="user.home_city" label="City" type="text"/>
                                    <v-text-field v-model="user.home_province" label="Province" type="text"/>
                                    <v-text-field v-model="user.home_postal_code" label="Postal Code" type="number"/>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item key="password" v-if="!config.registration.free">
                        <v-container color="transparent">
                            <v-layout row full-width>
                                <v-flex xs-12>
                                    <v-text-field v-model="user.password" label="Password" type="password" :rules="[rules.password]"/>
                                    <!--<v-text-field v-model="user.confirm_password" label="Confirm Password" type="password" :rules="[rules.confirmPassword]"/>-->
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-form>
        </v-content>
        <v-snackbar
                v-model="snackbar.visible"
                :bottom="true"
                :left="false"
                :multi-line="false"
                :right="false"
                :timeout="5000"
                :top="false"
                :vertical="false">

            {{ snackbar.message }}

            <v-btn flat @click="snackbar.visible = false">
                Close
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>
    import vas from "@/lib/VASClient"
    import {mapState, mapActions} from 'vuex'
    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                config: config,
                tab: null,
                genders: null,
                languages: null,
                snackbar: {
                    visible: false,
                    message: '',
                },
                user: {
                    language_id: null,
                    name: null,
                    surname: null,
                    sex: null,
                    home_address_1: null,
                    home_address_2: null,
                    home_city: null,
                    home_province: null,
                    home_postal_code: null,
                    password: '',
                    confirm_password: ''
                },
                rules: {
                    required(value) {
                        if (!value) {
                            return 'Required';
                        }

                        return true;
                    },
                    password(value) {
                        if (value !== null && value.length > 0 && value.length < 6) {
                            return 'Please provide a password longer than 6 characters';
                        }

                        return true;
                    },
                    confirmPassword(value, b) {
                        if (value != this.password) {
                            return 'Your passwords don\'t match';
                        }

                        return true;
                    }
                }
            }
        },
        created() {
            this.genders = vas.getGenders();
            this.languages = vas.getLanguages();

            this.user.name = this.auth.user.name;
            this.user.surname = this.auth.user.surname;
            this.user.sex = this.auth.user.sex;
            this.user.language_id = parseInt(this.auth.user.language_id);
            this.user.home_address_1 = this.auth.user.home_address_1;
            this.user.home_address_2 = this.auth.user.home_address_2;
            this.user.home_city = this.auth.user.home_suburb;
            this.user.home_province = this.auth.user.home_province;
            this.user.home_postal_code = this.auth.user.home_postal_code;
        },
        methods: {
            showSnackbar(message) {
                this.snackbar.message = message;
                this.snackbar.visible = true;
            },
            save() {
                if (!this.$refs.form.validate()) {
                    return;
                }

                var self = this;

                Loading.show('');

                vas.updateInfo(this.auth.user.cell_no,
                    this.auth.user.user_id,
                    this.auth.user.age,
                    this.user.sex,
                    this.auth.user.race,
                    this.auth.user.pregnant,
                    this.auth.user.weight,
                    this.auth.user.height,
                    this.auth.user.smoker,
                    this.auth.user.drinker,
                    this.auth.user.blood_type,
                    this.auth.user.illness,
                    this.auth.user.allergies,
                    this.user.home_address_1,
                    this.user.home_address_2,
                    this.user.home_city,
                    this.user.home_province,
                    this.user.home_postal_code,
                    this.auth.user.dependents,
                    this.auth.user.ice1,
                    this.auth.user.ice2,
                    this.user.name,
                    this.user.surname,
                    this.user.language_id,
                    this.user.password)
                    .then(function (response) {
                        self.auth.user.sex = self.user.sex;
                        self.auth.user.home_address_1 = self.user.home_address_1;
                        self.auth.user.home_address_2 = self.user.home_address_2;
                        self.auth.user.home_suburb = self.user.home_city;
                        self.auth.user.home_postal_code = self.user.home_postal_code;
                        self.auth.user.home_province = self.user.home_province;
                        self.auth.user.name = self.user.name;
                        self.auth.user.surname = self.user.surname;
                        self.auth.user.language_id = self.user.language_id;

                        self.user.password = '';
                        self.user.confirm_password = '';

                        self.$store.commit('auth/login', {user:self.auth.user});

                        Loading.hide();

                        self.showSnackbar("Your profile has been updated");
                    })
                    .catch(function (response) {
                        Loading.hide();

                        self.showSnackbar("An error occurred updating your profile");
                    });
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>